import { Listbox } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/solid';
import classNames from 'classnames';

import { Option } from './Select';

export interface SelectOptionProps {
  option: Option;
}

const SelectOption = ({ option }: SelectOptionProps) => {
  return (
    <Listbox.Option
      key={option.id}
      className={({ active, disabled }) =>
        classNames('relative cursor-default select-none py-2 pl-2 pr-5', {
          'text-white bg-emblue-primary': active,
          'text-gray-900': !active,
          '!text-emblue-disabled': disabled,
        })
      }
      disabled={option.disabled}
      value={option}
    >
      {({ selected, active }) => {
        return (
          <>
            <span
              className={classNames(
                selected ? 'font-semibold' : 'font-normal',
                'block truncate text-left'
              )}
            >
              {option.name}
            </span>

            {selected ? (
              <span
                className={classNames(
                  active ? 'text-white' : 'text-emblue-primary',
                  'absolute inset-y-0 right-0 flex items-center pr-1'
                )}
              >
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            ) : null}
          </>
        );
      }}
    </Listbox.Option>
  );
};

export default SelectOption;
